import {
    FETCH_HOW_TO_DETAILS_BEGIN,
    FETCH_HOW_TO_DETAILS_SUCCESS,
    FETCH_HOW_TO_DETAILS_FAILURE,
    SET_SELECTED_BRAND,
    SET_SELECTED_CATEGORY,
    SET_SELECTED_ARTICLE,
    VIEW_ENLARGED_IMAGE,
    CLOSE_ENLARGED_IMAGE,
    VIEW_HOWTOS_DETAIL,
    CLOSE_HOWTOS_DETAIL
} from '../constants/howTosActionTypes';
import { isMobile } from '../utils/index';

const initialState = {
    howTos: [],
    BrandsVal: [],
    categoryVal: [],
    isLoading: true,
    categoriesSelect: "",
    brandSelect: "",
    articleTypeSelect: "",
    articlesList: [],
    brandsList: [],
    categoriesList: [],
    articleTypeList: [],
    filterHeaderList: [],
    open: false,
    insideImage: false,
    popupValue: {},
    isMobile: isMobile(),
    mobilePageSection: 0,
    error: {}
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case FETCH_HOW_TO_DETAILS_BEGIN:
            return {
                ...state,
                isFetching: true
            };
        case FETCH_HOW_TO_DETAILS_SUCCESS:
            var result = action.payload;
            return {
                ...state,
                howTos: result,
                articlesList: result[0].view_2,
                brandsList: result[0].view,
                categoriesList: result[0].view_1,
                articleTypeList: result[0].view_3,
                filterHeaderList: result[0].view_4,
                isLoading: false,
                categoriesSelect: result[0].view_1 ? result[0].view_1.find((category) => category.tid === 'all'): '',
                brandSelect: result[0].view ? result[0].view.find((brand) => brand.tid === 'all') : '',
                articleTypeSelect: result[0].view_3 ? result[0].view_3.find((mediaDisplay) => mediaDisplay.tid === 'all') : ''
            };
        case FETCH_HOW_TO_DETAILS_FAILURE:
            return {
                ...state,
                error: action.payload,
                isFetching: false,
                contentLoaded: true,
                isLoading: false
            };
        case SET_SELECTED_CATEGORY:
            return {
                ...state,
                categoriesSelect: action.payload
            }
        case SET_SELECTED_BRAND:
            return {
                ...state,
                brandSelect: action.payload
            }
        case SET_SELECTED_ARTICLE:
            return {
                ...state,
                articleTypeSelect: action.payload
            }
        case VIEW_HOWTOS_DETAIL:
            return {
                ...state,
                open: true,
                popupValue: action.payload,
                mobilePageSection: 1
            }
        case CLOSE_HOWTOS_DETAIL:
            return {
                ...state,
                open: false,
                mobilePageSection: 0
            }
        case VIEW_ENLARGED_IMAGE:
            return {
                ...state,
                insideImage: true
            }
        case CLOSE_ENLARGED_IMAGE:
            return {
                ...state,
                insideImage: false
            }
        default:
            return state;
    }
}
